export const SUBSCRIPTION_PLANS  = {
    FREEMIUM: 'freemium',
    FREE_TRIAL: 'free_trial',
    STANDARD: 'std',
} as const;

export type SUBSCRIPTION_PLAN = typeof SUBSCRIPTION_PLANS[keyof typeof SUBSCRIPTION_PLANS];
export type PAID_SUBSCRIPTION_PLAN = 'std';


export const SUBSCRIPTION_ITEMS  = {
    STANDARD: 'standard',
    USER_SEAT: 'user_seat',
    LOCATION_SLOT: 'location_slot',
} as const;

export type SUBSCRIPTION_ITEM = typeof SUBSCRIPTION_ITEMS[keyof typeof SUBSCRIPTION_ITEMS];

export const priceItemMapping = {
    [import.meta.env.VITE_APP_PADDLE_STD_MONTHLY_ID]: SUBSCRIPTION_ITEMS.STANDARD,
    [import.meta.env.VITE_APP_PADDLE_STD_YEARLY_ID]: SUBSCRIPTION_ITEMS.STANDARD,
    [import.meta.env.VITE_APP_PADDLE_STD_USER_MONTHLY_ID]: SUBSCRIPTION_ITEMS.USER_SEAT,
    [import.meta.env.VITE_APP_PADDLE_STD_USER_YEARLY_ID]: SUBSCRIPTION_ITEMS.USER_SEAT,
    [import.meta.env.VITE_APP_PADDLE_STD_LOCATION_MONTHLY_ID]: SUBSCRIPTION_ITEMS.LOCATION_SLOT,
    [import.meta.env.VITE_APP_PADDLE_STD_LOCATION_YEARLY_ID]: SUBSCRIPTION_ITEMS.LOCATION_SLOT,
} as const;

export const getPriceItemById = (priceId: string): SUBSCRIPTION_ITEM => {
    return priceItemMapping[priceId];
}

export const getSubscriptionItemByPlan = (plan: PAID_SUBSCRIPTION_PLAN): SUBSCRIPTION_ITEM => {
    switch (plan) {
        case SUBSCRIPTION_PLANS.STANDARD:
            return SUBSCRIPTION_ITEMS.STANDARD;
    }
}
